import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import logo from '../../assets/logo.png';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle forgot password logic, then navigate to OTP page
    console.log(email);
    navigate('/auth/otp', { state: { email } });
  };

  return (
    <div className="flex flex-col md:flex-row w-full min-h-screen bg-white" dir="rtl">
      {/* Left side decorative image */}
     
        <img
           src={'../Forgotyourpassword.png'}
          alt="Security"
          className="w-1/2"
        />
    

      {/* Right side form */}
      <div className="w-full md:w-1/2 bg-gray-50 flex flex-col items-center justify-center p-8">
        <div className="max-w-md w-full">
          <div className="flex justify-between items-center mb-8">
             <img src={logo} alt="Logo" className="h-10" />
            <Link to="/auth/login" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[var(--Primary-Primary)]">
              رجوع
              <ChevronRight size={20} className="transform rotate-180" />
            </Link>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-center mb-2 text-[#1D2035]">نسيت كلمة المرور</h2>
            <p className="text-center text-gray-500 mb-6 text-sm">
              إعادة تعيين كلمة مرور حسابك والوصول إلى تسجيل الدخول مرة أخرى.
            </p>
            
            {/* Progress Bar */}
            <div className="flex items-center justify-center my-8">
                <div className="w-1/3 h-1 bg-[var(--Primary-Primary)] rounded-full"></div>
                <div className="w-1/3 h-1 bg-gray-200 rounded-full"></div>
                <div className="w-1/3 h-1 bg-gray-200 rounded-full"></div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block mb-2 font-medium text-right text-gray-700">البريد الإلكتروني</label>
                <input
                  type="email"
                  id="email"
                  className="w-full border border-gray-200 rounded-md px-3 py-3 text-right focus:outline-none focus:ring-2 focus:ring-gray-200"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  autoFocus
                  placeholder="أدخل بريدك الإلكتروني"
                />
              </div>
              
              <button
                type="submit"
                className="w-full text-white py-3 rounded-md bg-[var(--Primary-Primary)] hover:bg-opacity-90 transition-colors duration-300 font-semibold"
              >
                استمر
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
